<app-topnav></app-topnav>


<!-- HEADER -->
<app-header-secondary-f  [pageTitle]="'nosclients.title' | translate" 
[pageDescription]="'nosclients.description' | translate" [imageURL]="'assets/img/header/headerf-blob-clients.png'"></app-header-secondary-f>

<!-- end HEADER -->

<section  id="section-clients">
    <div class="container" id="section-clients-inner">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-12" *ngIf="currentLang ==='fr'">
                    <h2 class="section-title">
                        <span>À l'écoute de nos clients</span>
                    </h2>
                    <p>Nous effectuons régulièrement des sondages pour savoir ce que les clients de Plurilogic pensent de nos produits et services. Cela nous maintient à jour en plus de nous aider à nous améliorer et à conserver un niveau élevé de satisfaction de nos clients. Voici une sélection des commentaires des personnes qui utilisent nos solutions quotidiennement.</p>
                </div>
                <div class="col col-12" *ngIf="currentLang ==='en'">
                        <h2 class="section-title">
                            <span>Listening to our customers</span>
                        </h2>
                        <p>We conduct regular surveys to find out what Plurilogic customers think about our products and services. It keeps us up-to-date and helps us improve and maintain a high level of customer satisfaction. Here is a selection of comments from people who use our solutions daily.</p>
                    </div>
                </div>
        </div>
    
        <p>&nbsp;</p>
        <p>&nbsp;</p>

            
                <div class="container-fluid">
                        <div class="row">
                            <div class="col col-12 col-md-5">
                                <img class="clients-blob white-blob-bubble-a1" src="assets/img/pages/white_bubble_a1.svg" />    
                                <img class="clients-blob blob-client1" src="assets/img/nosclients/AMC.svg" />
                                <img class="page-blob blob-white blob-white-page-1" src="assets/img/blobs/blob_white.svg">
                                <img class="page-blob blob-white blob-white-page-2" src="assets/img/blobs/blob_white.svg">
                                <img class="page-blob blob-white blob-white-page-3" src="assets/img/blobs/blob_white.svg">
                            </div>
                            <div class="col col-12 col-md-7 offset-md-5 offset-lg-0 extra-margin-top1">
                                
                                <h2 class="leftAlign textMiniA"><strong>Académie Marie-Claire</strong></h2>
                                <p class="leftAlign">Des recherches approfondies ont été effectuées avant de choisir Plurilogic, Inc. en tant qu’application de gestion pour notre école.</p>
                                <p class="leftAlign">10 ans plus tard, nous croyons toujours en cette décision. Ce logiciel intégré et pratique a répondu à tous nos objectifs. Sa facilité d’utilisation et la variété de rapports offerts surpasse nos attentes. La qualité du service inégalée repose sur la diligence, la flexibilité, l’efficacité, le professionnalisme de l’équipe et la courtoisie en tout temps. Selon nous, il n’y a pas de meilleur système.</p>
                                <p class="leftAlign">Henry Zephirin, <i>Directeur</i></p>
                            </div>
                        </div>
                    </div>

        <p>&nbsp;</p>
        <p>&nbsp;</p>

                    
                    <div class="container-fluid">
                            <div class="row">
                                <div class="col col-12 col-md-5 order-md-2 offset-lg-0">
                                    <img class="clients-blob white-blob-bubble-a2" src="assets/img/pages/white_bubble_a2.svg" />    
                                    <img class="clients-blob blob-client2" src="assets/img/nosclients/ASA.svg" />
                                    <img class="page-blob blob-white blob-white-page-4" src="assets/img/blobs/blob_white.svg">
                                    <img class="page-blob blob-white blob-white-page-5" src="assets/img/blobs/blob_white.svg">
                                </div>
                                <div class="col col-12 col-md-7 order-md-1 offset-md-1 extra-margin-top2">
                                        <h2 class="leftAlign textMiniA"><strong>Académie Ste-Anne</strong></h2>
                                        
                                    <p class="leftAlign">La collaboration avec le service à la clientèle de Plurilogic est efficace et efficiente.  Les employés au soutien nous ont littéralement facilité la vie à l’ouverture de l’Académie Sainte-Anne et continuent de le faire au quotidien!</p>
                                    <p class="leftAlign">Véronique Boulet, <i>Directrice de la cinquième secondaire</i></p>
                                </div>
                            </div>
                        </div>

        <p>&nbsp;</p>
        <p>&nbsp;</p>

<!--
                        <div class="container-fluid">
                                <div class="row">
                                    <div class="col col-12 col-md-5">
                                            <img class="clients-blob white-blob-bubble-a3" src="assets/img/pages/white_bubble_a3.svg" />    
                                        <img class="clients-blob blob-client3" src="assets/img/nosclients/AVaudring.svg" />
                                        <img class="page-blob blob-white blob-white-page-6" src="assets/img/blobs/blob_white.svg">
                                        <img class="page-blob blob-white blob-white-page-7" src="assets/img/blobs/blob_white.svg">
                                    </div>
                                    <div class="col col-12 col-md-7 offset-md-5 offset-lg-0 extra-margin-top3">
                                            <h2 class="leftAlign textMiniA"><strong>l’Académie Vaudrin </strong></h2>
                                            
                                        <p class="leftAlign">Seul un administrateur d'école peut comprendre les complexités et défis inhérents à la gestion d'une école. Je m’explique : les employés de Plurilogic les comprennent également, que ce soit pour la comptabilité, les bulletins, la prise de présences ou la communication avec les enseignants ainsi qu’avec les élèves et leurs parents. Plurilogic a toujours fourni un service impeccable pour répondre à tous nos besoins; c’est un de nos fournisseurs de services préférés depuis nos débuts. En fait, notre petite école a toujours considéré ses employés comme une famille parce qu’ils se soucient vraiment de nous.</p>
                                        <p class="leftAlign">Michelle Vaudrin, <i>Directrice/Présidente de l’Académie Vaudrin</i></p>
                                    </div>
                                </div>
                            </div>

                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                    
-->
<!--

                                        <div class="container-fluid">
                                                <div class="row">
                                                    <div class="col col-12 col-md-5 order-md-2 offset-lg-0">
                                                        <img class="clients-blob white-blob-bubble-a4" src="assets/img/pages/white_bubble_a2.svg" />
                                                        <img class="clients-blob blob-client4" src="assets/img/nosclients/ECdeLS.svg" />
                                                        <img class="page-blob blob-white blob-white-page-8" src="assets/img/blobs/blob_white.svg">
                                                        <img class="page-blob blob-white blob-white-page-9" src="assets/img/blobs/blob_white.svg">
                                                    </div>
                                                    <div class="col col-12 col-md-7 order-md-1 offset-md-1 extra-margin-top2">
                                                            <h2 class="leftAlign textMiniA"><strong>École Cavelier-De LaSalle</strong></h2>
                                                            
                                                            <p class="leftAlign">« Depuis que nous avons mis en place un système de retard en scannant les cartes étudiantes, cela nous permet un suivi plus rapide et efficace. »</p>
                                                            <p class="leftAlign">« Avec le Pluriportail, il est possible de générer facilement des statistiques de retard, d’absence, de comportement, etc. afin de pouvoir avoir un portrait précis des élèves et intervenir pour mettre en place des mesures de soutien. »</p>
                                                            <p class="leftAlign">« Le Pluriportail facilite la communication-école-famille, en générant des groupes automatiques pour envoyer des courriels ou en créant des communiqués ciblés. »</p>
                                                            <p class="leftAlign">« La création des dossiers d’accompagnement, nous ont permis de mettre en place des canevas selon nos besoins et de mettre en collaboration et d’informer automatiquement la direction, les enseignants impliqués, les intervenants et les parents. »</p>
                                                            <p class="leftAlign">Catherine Houle, <i>Conseillère pédagogique TIC - École Cavelier-De LaSalle</i></p>
                                                    </div>
                                                </div>
                                            </div>

                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
-->
                     
                     <div class="container-fluid">
                        <div class="row">
                            <div class="col col-12 col-md-5">
                                    <img class="clients-blob white-blob-bubble-a5" src="assets/img/pages/white_bubble_a3.svg" />    
                                <img class="clients-blob blob-client5" src="assets/img/nosclients/Socrates.svg" />
                                <img class="page-blob blob-white blob-white-page-6" src="assets/img/blobs/blob_white.svg">
                                <img class="page-blob blob-white blob-white-page-7" src="assets/img/blobs/blob_white.svg">
                            </div>
                            <div class="col col-12 col-md-7 offset-md-5 offset-lg-0 extra-margin-top3">
                                    <h2 class="leftAlign textMiniA"><strong>École Socrates-Démosthène</strong></h2>
                                    <p class="leftAlign">Nous utilisons les services de Plurilogic depuis plus de 10 ans et nous avons toujours eu une excellente expérience.</p>
                                  </div>
                        </div>
                    </div>

                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                      

</div>
</section>

<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>
